import { I18n } from '@calendly/i18n';
import { AddMiniIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "cbvlfkv";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const AddLocation = ({
  multipleLocationsAdded = false,
  onClick
}) => <Container>
    {!multipleLocationsAdded && <BodyText size="medium">
      {I18n.t('publisher.event_type_editor.sections.event_details.location.add_location_prompt')}
    </BodyText>}
    <MinimalButton fontSize="medium" spacingTop="8" onClick={onClick}>
      <AddMiniIcon />
      {I18n.t('publisher.event_type_editor.sections.event_details.location.add_location_button')}
    </MinimalButton>
  </Container>;

require("./add_location.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./add_location.js");